import { defineStore } from 'pinia'
import { useNuxtApp, useRuntimeConfig } from 'nuxt/app'
import type moment from 'moment'

type FlagsState = {
  isFetched: boolean
  flags: {
    /* eslint-disable-next-line camelcase, @typescript-eslint/naming-convention */
    signup_campaign_active: boolean
    /* eslint-disable-next-line camelcase, @typescript-eslint/naming-convention */
    signup_campaign_active_last_day: boolean
  }
}

export const useFlagsStore = defineStore('flags', {
  state: (): FlagsState => ({
    isFetched: false,
    flags: {
      signup_campaign_active: false,
      signup_campaign_active_last_day: false
    }
  }),
  getters: {
    isTwoForOneCampaign: (state: FlagsState): boolean => state.flags.signup_campaign_active,
    isTwoForOneCampaignLastDay: (state: FlagsState): boolean => state.flags.signup_campaign_active_last_day,
    isFlagsFetched: (state: FlagsState): boolean => state.isFetched
  },
  actions: {
    async fetchFlags() {
      const nuxtApp = useNuxtApp()
      const $moment = nuxtApp.$moment as typeof moment
      const {
        public: { API_URL }
      } = useRuntimeConfig()

      const data = await $fetch<any>(`${API_URL}/v2/flags`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      })

      const showfromDate = $moment.utc('05-02-2025', 'DD-MM-YYYY')
      const showtoDate = $moment.utc('27-02-2025', 'DD-MM-YYYY')
      const signupCampaignActive = $moment.utc().isBetween(showfromDate, showtoDate)
      const signupCampaignActiveLastDay = $moment.utc().isSame(showtoDate.clone().subtract(1, 'day'), 'day')

      const transformedData = {
        ...data,
        signup_campaign_active: signupCampaignActive || data.signup_campaign_active,
        signup_campaign_active_last_day: signupCampaignActiveLastDay || data.signup_campaign_active_last_day
      }

      this.flags = transformedData
      this.isFetched = true

      return transformedData
    }
  }
})
